import {useCallback, useEffect, useRef, useState} from 'react';
import {ProgressRef} from 'components/Loaders/Progress';
import useGetUiLongTaskProgress, {
    LongTask,
    LongTaskResponseErrorResponse,
} from 'hooks/useGetLongTaskProgress';

const useLongTask = (
    urlBuilder: (longTaskMid: string) => void,
    initialLongTask: LongTask | undefined = undefined,
) => {
    const {mutateAsync} = useGetUiLongTaskProgress();

    const [longTask, setLongTask] = useState<LongTask | undefined>(
        initialLongTask,
    );
    const progressRef = useRef<ProgressRef>(null);
    const [longTaskApiError, setLongTaskApiError] =
        useState<LongTaskResponseErrorResponse>();

    const url = longTask ? urlBuilder(longTask.mid) : null;
    const isActive =
        !!longTask?.mid &&
        !longTask?.finished &&
        !longTaskApiError &&
        longTask?.uilongtask.errors.length === 0;

    const pollingFunction = useCallback(() => {
        if (isActive && url) {
            mutateAsync(url)
                .then((res) => {
                    if (res) {
                        setLongTask(res.data);
                        progressRef.current?.setProgress(res.data.completion);
                    }
                })
                .catch((error) => {
                    setLongTaskApiError(error);
                });
        }
    }, [isActive, mutateAsync, url]);

    useEffect(() => {
        const interval = setInterval(pollingFunction, 1000);

        return () => clearInterval(interval);
    }, [pollingFunction]);

    const onFinish = () => {
        setLongTask(undefined);
        setLongTaskApiError(undefined);
        progressRef.current?.setProgress(0);
    };

    return {longTask, longTaskApiError, onFinish, progressRef, setLongTask};
};

export default useLongTask;
